import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Check.svg",
  "use": "Check.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Check.svg\"><path d=\"M56.0106,47.0209h-48a2,2,0,0,1-2-2v-26a2,2,0,0,1,2-2h48a2,2,0,0,1,2,2v26A2,2,0,0,1,56.0106,47.0209Zm-33-24h-12a1,1,0,1,0,0,2h12a1,1,0,0,0,0-2Zm16,8h-28a1,1,0,1,0,0,2h28a1,1,0,1,0,0-2Zm15-5a1,1,0,0,0-1-1h-8a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1Zm-1,13h-12a1,1,0,0,0,0,2h12a1,1,0,1,0,0-2Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol